import React, {  } from 'react';

import { dateTimeFormatOptions } from '../types';
import { DateTimeFormatRangeInput, DatTimeFormatRuleSet } from './Intl.DateTimeFormat';
import { IntlFunction } from './Intl.Function';

export const IntlDateTimeFormatFormatRange = () => (
	<IntlFunction
		input={DateTimeFormatRangeInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatRange"
		header="Intl.DateTimeFormat.prototype.formatRange"
		description="Formats a date range in the most concise way based on the **`locale`** and **`options`** provided when instantiating [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat) object."
		options={dateTimeFormatOptions}
		ruleSet={DatTimeFormatRuleSet}
		template="new Intl.DateTimeFormat(##locale##, ##options##).formatRange(##input:raw##)" />
)